import { render, staticRenderFns } from "./ReporteCliente.vue?vue&type=template&id=024464aa&"
import script from "./ReporteCliente.vue?vue&type=script&lang=js&"
export * from "./ReporteCliente.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCliente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports